import { Icon, mergeStyleSets, Panel, PanelType } from "office-ui-fabric-react";
import React, { useState } from "react";
import { connect } from "react-redux";
import { State } from "../../store";
import * as GeneralStore from "../../store/GeneralStore";
import * as TruckNominationStore from "../../store/TruckNominationStore";
import FileUpload from "./common/FIleUpload";

type Props = TruckNominationStore.TruckNominationState &
  GeneralStore.GeneralState;

const classes = mergeStyleSets({
  viewButtonUpload: {
    width: "39px",
    height: "39px",
    borderRadius: "5px",
    border: "1px solid #E2E6E8",
    backgroundColor: "#FAFAFA",
    display: "block",
    padding: "0",
    cursor: "pointer",
    selectors: {
      ":hover": {
        backgroundColor: "#EEEEEE",
        textDecoration: "none",
      },
    },
  },
  viewIconUpload: {
    color: "#4C4C4C",
    margin: "auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    width: "100%",
    textAlign: "center",
  },
});

const AttachmentModal: React.FC<Props> = (props: Props) => {
  const [isOpenAttachment, setIsOpenAttachment] = useState(false);
  const { truckNomination } = props;
  return (
    <>
          {!truckNomination.isLoading && truckNomination.result && (
          <div>
              <div
                  style={{
                      textAlign: 'center',
                      display: 'flex',
                      alignItems: 'center',
                      flexDirection: 'column',
                  } }
                  onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        setIsOpenAttachment(true);
                  }}>
                      <div style={{
                          height: 48, width: 48, padding: 12,
                          borderRadius: '50%',
                          background: '#F3F4F6',
}} >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g id="attach_file">
                            <mask id="mask0_6_594" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                <rect id="Bounding box" width="24" height="24" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_6_594)">
                                <path id="attach_file_2" d="M17.6731 15.6442C17.6731 17.2682 17.108 18.6501 15.9779 19.7901C14.8478 20.93 13.4721 21.5 11.851 21.5C10.2298 21.5 8.8526 20.93 7.71926 19.7901C6.58595 18.6501 6.01929 17.2682 6.01929 15.6442V6.65383C6.01929 5.49999 6.41992 4.51923 7.22119 3.71155C8.02247 2.90385 9.00003 2.5 10.1539 2.5C11.3077 2.5 12.2853 2.90385 13.0865 3.71155C13.8878 4.51923 14.2885 5.49999 14.2885 6.65383V15.1634C14.2885 15.8403 14.0527 16.4182 13.5812 16.8971C13.1096 17.3759 12.535 17.6153 11.8571 17.6153C11.1793 17.6153 10.601 17.3776 10.1222 16.9021C9.64331 16.4265 9.40389 15.847 9.40389 15.1634V6.38463H10.9039V15.1634C10.9039 15.4314 10.9939 15.657 11.174 15.8404C11.3542 16.0237 11.5782 16.1154 11.8462 16.1154C12.1141 16.1154 12.3382 16.0237 12.5183 15.8404C12.6984 15.657 12.7885 15.4314 12.7885 15.1634V6.64423C12.7782 5.90576 12.5218 5.28043 12.0191 4.76825C11.5164 4.25607 10.8947 3.99998 10.1539 3.99998C9.41618 3.99998 8.79265 4.25767 8.28329 4.77305C7.77392 5.28843 7.51924 5.91536 7.51924 6.65383V15.6442C7.50899 16.8532 7.92694 17.8814 8.77309 18.7288C9.61925 19.5763 10.6464 20 11.8545 20C13.0455 20 14.058 19.5763 14.8917 18.7288C15.7255 17.8814 16.1526 16.8532 16.1731 15.6442V6.38463H17.6731V15.6442Z" fill="#1C1B1F" />
                            </g>
                        </g>
                      </svg>
                  </div>
        </div>
                  <div style={{
                      fontSize: 12,
                          textAlign: "center" }}> Attachment</div>
                  </div>
      )}
      {isOpenAttachment && (
        <Panel
          isLightDismiss
          isOpen={isOpenAttachment}
          onDismiss={() => setIsOpenAttachment(false)}
          closeButtonAriaLabel="Close"
          type={PanelType.smallFluid}
          className="upload-panel"
          layerProps={{ eventBubblingEnabled: true }}
          styles={{
            scrollableContent: { overflow: "visible" },
            content: { overflow: "visible" },
          }}
        >
          <FileUpload
            nomination={truckNomination.result!}
            canUploadFile={props.isTruckUploadFileAllowed}
            modality={1}
          />
        </Panel>
      )}
    </>
  );
};

export default connect(
  (state: State) => ({
    ...state.general,
    ...state.truckNomination,
  }),
  null
)(AttachmentModal as any);
